const inputsValidations = {
  emailRequired: "البريد الإلكتروني مطلوب",
  nameRequired: "الاسم مطلوب",
  enNameRequired: "الاسم باللغة الانجليزية مطلوب",
  arNameRequired: "الاسم باللغة العربية مطلوب",
  pickOneCategoryAtLeast: "يجب اختيار فئة واحدة علي الأقل",
  specialtyRequired: "اختيار التخصص مطلوب",
  logoRequired: "اختيار الشعار مطلوب",
  cityRequired: "المدينة المسجلة مطلوبة",
  commercialRecordRequired: "رقم السجل التجاري مطلوب",
  commercialRecordTenDigitsOnly: "يجب أن يتكون رقم السجل التجاري من 10 أرقام فقط",
  crDocumentRequired: "مستند السجل التجاري (PDF) مطلوب",
  delegationDocumentRequired: "مستند التفويض (PDF) مطلوب",
  personalIdDocumentRequired: "مستند الهوية (PDF, JPG أو PNG) مطلوب",
  bannerRequired: "اختيار صورة الغلاف مطلوب",
  categoryRequired: "اختيار الفئة مطلوبة",
  roleRequired: "الوظيفة مطلوبة",
  languageRequired: "اللغة مطلوبة",
  passwordRequired: "كلمة المرور مطلوبة",
  tempPasswordRequired: "كلمة المرور المؤقتة مطلوبة ",
  oldPasswordRequired: "كلمة المرور القديمة مطلوبة ",
  newPasswordRequired: "كلمة مرور الجديدة مطلوبة",
  validEmailFormat: "يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا",
  businessEmailPublicProvider:
    "يُرجى استخدام بريد شركتك الإلكتروني (ليس Gmail أو Yahoo وغيرها)",
  uniqeEmailRequired:
    "يتم استخدام هذا البريد الإلكتروني من قبل، ويجب أن يكون البريد الإلكتروني موحدًا",
  confirmNewPasswordRequired: "تأكيد كلمة المرور الجديدة مطلوب",
  passwordIsNotMatched: "كلمات المرور يجب أن تتطابق",
  passwordNotFollowREGEX:
    "يجب أن تحتوي كلمات المرور على 8 أحرف على الأقل ؛ مزيج من الأحرف (الكبيرة والصغيرة) والأرقام والرموز",
  nameNotFollowREGEX: "الاسم لا يجب أن يحتوى علي رموز",
  nameNotFollowAlphabeticREGEX: "الاسم لا يجب أن يحتوى علي رموز او ارقام",
  englishLettersOnly: "هذا الحقل يقبل اللغة الانجليزية فقط",
  arabicLettersOnly: "هذا الحقل يقبل اللغة العربية فقط",
  ibanMaxLength: "رقم الآيبان يجب ألا يتجاوز 24 رقمًا",
  ibanMustStartWithSA: "رقم الآيبان يجب أن يبدأ بـ SA",
  ibanExactLength: "رقم الآيبان يجب أن يتكون من 24 رقمًا بالضبط",
  matloobNumberWrongLength: "رقم مطلوب يجب أن يكون 9 خانات",
  onlyPositiveNumber: "هذا الحقل يقبل أرقام صحيحة فقط",
  mustBeGreaterThanZero: "يجب أن يكون أكبر من 0",
  onlyPositiveNumbersWithZero: "هذا الحقل يقبل صفر أو أرقام صحيحة فقط",
  onlyPositiveNumberWithMaxTwoDecimalPlaces:
    "هذا الحقل يقبل أرقام  فقط بحد أقصي رقميين عشريين",
  userTypeRequired: "نوع المستخدم مطلوب",
  eventNameRequired: "اسم الفعالية مطلوب",
  eventBriefRequired: "النبذة عن الفعالية مطلوبة",
  startBuildUpDateNotAfterEnd: "تاريخ البداية يجب أن يكون قبل تاريخ النهاية",
  endBuildUpDateNotBeforeStart: "تاريخ النهاية يجب أن يكون بعد تاريخ البداية",
  eventStartDateNotAfterEnd: "تاريخ البداية يجب أن يكون قبل تاريخ النهاية",
  eventEndDateNotBeforeStart: "تاريخ النهاية يجب أن يكون بعد تاريخ البداية",
  dismantlingStartDateNotAfterEnd:
    "تاريخ البداية يجب أن يكون قبل تاريخ النهاية",
  dismantlingEndtDateNotBeforeStart:
    "تاريخ النهاية يجب أن يكون بعد تاريخ البداية",
  shouldNotBeBeforeToday: "التاريخ لا يجب أن يكون قبل اليوم",
  dateCannotBeFuture: "لا يمكن أن يكون التاريخ في المستقبل",
  invalidDate: "أدخل تاريخاً صحيحاً",
  invalidTime: "أدخل وقتاً صحيحاً",
  maxHundredChars: "الحد الأقصى 100حرف",
  maxFiveHundredChars: "الحد الأقصى 500حرف",
  maxTowHundredChars: "الحد الأقصى 200حرف",
  maxFiftyChars: "الحد الأقصى 50حرف",
  generalFieldRequired: "هذا الحقل مطلوب",
  checkoutCannotBeBeforeCheckin: "وقت الخروج لا يمكن أن يكون قبل وقت الدخول",
  checkoutDateMustBeAfterCheckinDate:
    "يجب أن يكون تاريخ الخروج بعد وقت تسجيل الدخول",
  checkoutTimeMustBeAfterCheckinTime:
    "يجب أن يكون وقت الخروج بعد وقت تسجيل الدخول",
  checkoutCannotBeCleared:
    "لا يمكن مسح تاريخ ووقت تسجيل الخروج بعد تعيينهما",
  slotShiftCheckInOutsideMargin:
    "يجب أن يكون وقت تسجيل الدخول ضمن وقت الوردية وهامش تسجيل الدخول",
  slotShiftCheckOutOutsideMargin:
    "يجب أن يكون وقت تسجيل الخروج ضمن وقت الوردية وهامش تسجيل الخروج",
  slotTrainingCheckInOutsideMargin:
    "يجب أن يكون وقت تسجيل الدخول ضمن وقت التدريب وهامش تسجيل الدخول",
  slotTrainingCheckOutOutsideMargin:
    "يجب أن يكون وقت تسجيل الخروج ضمن وقت التدريب وهامش تسجيل الخروج",
  slotDateOutsideEventPeriod: "يجب أن يكون التاريخ ضمن فترة الفعالية",
  slotDateTimeCannotBeFuture: "لا يمكن أن يكون التاريخ والوقت في المستقبل",
  checkoutFieldsRequiredTogether:
    "أدخل تاريخ ووقت الخروج معاً، أو اتركهما فارغين",
  invalidPhone: "رقم هاتف غير صحيح",
  requiredDate: "هذا التاريخ مطلوب",
  max1000: "الحد الأقصي 1000 حرف بدون علامات",
  max500: "الحد الأقصي 500 حرف بدون علامات",
  max300: "الحد الأقصي 300 حرف بدون علامات",
  generalFieldRequiredToPublish: "هذا الحقل مطلوب",
  eventRoleRequired: "أضف دوراً واحداً على الأقل",
  eventSupervisorRoleRequired: "أضف دور مشرف (Supervisor) واحد على الأقل",
  eventShiftRequired: "أضف وردية واحدة على الأقل",
  eventRoleCapacityRequired: "لا يمكن أن تكون سعة الذكور والإناث صفراً معاً",
  eventImageRequired: "صورة الفعالية مطلوبة",
  verificationMethodRequired: "طريقة التحقق من تسجيل الوصول مطلوبة",
  checkinStartMarginMax: "يجب ألا يتجاوز هامش بدء تسجيل الوصول 240 دقيقة",
  checkinEndMarginMax: "يجب ألا يتجاوز هامش إنهاء تسجيل الوصول 240 دقيقة",
  checkinMarginsTotalMax:
    "يجب ألا يتجاوز إجمالي هوامش البداية والنهاية لتسجيل الوصول 240 دقيقة",
  checkinMarginsTotalMin:
    "إجمالي هوامش البداية والنهاية لتسجيل الوصول يجب أن يكون أكبر من 0",
  checkoutStartMarginMax: "يجب ألا يتجاوز هامش بدء تسجيل المغادرة 240 دقيقة",
  checkoutEndMarginMax: "يجب ألا يتجاوز هامش إنهاء تسجيل المغادرة 240 دقيقة",
  checkoutMarginsTotalMax:
    "يجب ألا يتجاوز إجمالي هوامش البداية والنهاية لتسجيل المغادرة 240 دقيقة",
  checkoutMarginsTotalMin:
    "إجمالي هوامش البداية والنهاية لتسجيل المغادرة يجب أن يكون أكبر من 0",
  marginsOverlapWithSlot:
    "يجب أن يكون إجمالي هامش نهاية تسجيل الوصول وهامش بدء تسجيل المغادرة أقل من عدد ساعات العمل",
  payrollAmountMustBePositive: "هذا الحقل يقبل فقط الأعداد الصحيحة الموجبة.",
  roleNameRequired: "اسم الدور مطلوب",
  termsRequired: "يجب الموافقة على الشروط والأحكام.",
  trainingNameRequired: "اسم التدريب مطلوب",
  trainingNameInvalid:
    "هذا الحقل يقبل الحروف والأرقام والرموز الخاصة فقط.",
  trainingPaidAmountInvalid:
    "هذا الحقل يقبل أرقامًا بحد أقصى رقمين عشريين.",
  trainingEndBeforeStart:
    "لا يمكن أن يكون تاريخ ووقت النهاية قبل تاريخ ووقت البداية",
  trainingEndTimeBeforeStartTime:
    "لا يمكن أن يكون وقت النهاية قبل وقت البداية.",
  trainingEndMustBeBeforeEventEnd:
    "يجب أن يكون تاريخ ووقت انتهاء التدريب قبل تاريخ ووقت انتهاء الفعالية",
  trainingStartMustBeBeforeEventEnd:
    "يجب أن يكون تاريخ ووقت بدء التدريب قبل تاريخ ووقت انتهاء الفعالية",
  trainingConflictWithShift:
    "وقت التدريب يتعارض مع وقت الوردية. يرجى اختيار وقت تدريب لا يتداخل مع الوردية.",
  trainingLocationInvalid:
    "يرجى اختيار موقع صحيح من الخريطة أو إدخال عنوان صحيح.",
  pastDateTime: "لا يمكن أن يكون التاريخ والوقت في الماضي.",
  endDateBeforeStartDate: "تاريخ النهاية لا يمكن أن يكون قبل تاريخ البداية",
  registrationDocumentTypeInvalid:
    "يُسمح فقط بملفات PDF أو JPG أو PNG.",
  registrationDocumentMaxSize: "يجب ألا يتجاوز حجم الملف 5 ميجابايت.",
  logoDimensionsError: "يجب ألا تتجاوز أبعاد الصورة 800×400 بكسل",
};

export default inputsValidations;
  
